import React, { ReactNode, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import Loading from 'src/components/Loading/Loading'
import Secret from './Steps/Secret'
import LoginForm from './Steps/LoginForm'

import './Login.sass'

export type LoginSteps = 
'loading' | 
'missing-secret' | 
'invalid-secret' | 
'too-many-tries' | 
'idle' | 
'error' |
'password-expired'

const Login = () => {

  const [status, setStatus] = useState<LoginSteps>('idle')
  const userIdRef = useRef<string>(null)

  const handleUserId = (userId: string) => { userIdRef.current = userId }

  const statusRecord: Record<LoginSteps, ReactNode> = {
    loading: <Loading />,
    idle: <LoginForm handleStatus={setStatus} status={status} handleUserId={handleUserId} />,
    'invalid-secret': <Secret
      status="invalid-secret"
      handleStatus={setStatus}
      userId={userIdRef.current}
    />,
    'missing-secret': <Secret
      status="missing-secret"
      handleStatus={setStatus}
      userId={userIdRef.current}
    />,
    'too-many-tries': <LoginForm
      handleStatus={setStatus}
      status="too-many-tries"
      handleUserId={handleUserId}
      error="login.error-429"
    />,
    error: <LoginForm handleStatus={setStatus} status={status} handleUserId={handleUserId} error="login.error" />,
    'password-expired': <LoginForm
      handleStatus={setStatus}
      status={status}
      handleUserId={handleUserId}
      error="login.error.password-expired"
    />
  }

  console.log(status)
  return (
    <div id="login" className="page">
      <header id="login-header">{/* <ClientSupport /> */}</header>
      <div className="split">
        <div className="item item-left" />
        <div className="item item-right">
          <div className="wrapper">
            <Link to="/" className="logo" />
            <div className="login-form">
              <h1>
                <FormattedMessage id="login.title" />
              </h1>
              {statusRecord[status]}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
